import ApiClientError from './ApiClientError';
import ApiClientRequest from './ApiClientRequest';

function buildMessage(request: ApiClientRequest | null, statusCode: number | null, errors: ApiClientError[]): string {
	return `API Error${statusCode ? ` ${statusCode}` : ''}${request ? ` at ${request.url}` : ''}${
		errors.length > 0 ? `, errors: ${errors.map((error) => error.code).join(', ')}` : ''
	}`;
}

export default class ApiClientErrorResponse {
	request: ApiClientRequest | null;

	statusCode: number | null;

	errors: ApiClientError[];

	unhandledErrors: ApiClientError[];

	error: Error;

	static wrapError<Error>(error: Error, specializedResponseType: any): Promise<ApiClientErrorResponse | Error> {
		return Promise.reject(
			error instanceof ApiClientErrorResponse
				? new specializedResponseType(error.request, error.statusCode, error.errors)
				: error
		);
	}

	constructor(request: ApiClientRequest | null, statusCode: number | null, errors: ApiClientError[]) {
		const error = new Error(buildMessage(request, statusCode, errors));
		error.name = 'ApiClientErrorResponse';

		try {
			throw error;
		} catch (tmp) {
			this.error = tmp as Error;
		}

		this.request = request;
		this.statusCode = statusCode;
		this.errors = errors;
		this.unhandledErrors = errors;
	}

	handle(errorCode: string | null): boolean {
		return this.handleWith((error) => error.code === errorCode);
	}

	handleWith(handler: (error: ApiClientError) => boolean): boolean {
		const newUnhandledErrors = this.unhandledErrors.filter((error) => !handler(error));
		const handle = newUnhandledErrors.length !== this.unhandledErrors.length;
		this.unhandledErrors = newUnhandledErrors;
		return handle;
	}

	isHandled(): boolean {
		return this.unhandledErrors.length === 0;
	}

	asError(): Error {
		this.error.message = buildMessage(this.request, this.statusCode, this.unhandledErrors);
		return this.error;
	}
}
